import _ from 'lodash'
import { service } from 'boot/service'
import { useAuthStore, useGeneralStore } from 'src/stores'

const generalStore = useGeneralStore()
const authStore = useAuthStore()

export const checkVersion = async () => {
  if (_.keys(authStore.loginData).length) {
    const { meta } = await service.general.shakeHand()

    let portalVersion = meta.portal_version
    if (portalVersion) {
      portalVersion = portalVersion.split('.').join('')

      const newVersion = Number(portalVersion)
      const lastVersion = generalStore.portalVersion

      if (!lastVersion || lastVersion < newVersion) {
        generalStore.portalVersion = newVersion
        process.env.CLIENT && location.reload()
      }
    }
  }
}
